import React from "react"
import { useBooleanSearchParam, ProviderFinderParam } from "../../utils/providerFinderSearchUrl"
import { FormattedMessage, useIntl } from "react-intl"
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Typography
} from "@carrotfertility/carotene-core"
import { MemberActions } from "#/services/memberActionTracking/memberActions"
import { useMemberActionTracking } from "#/services/memberActionTracking/useMemberActionTracking"
import { useJourney } from "#/components/carrot-plans/hooks/useJourney"

export function VirtualServicesFilter(): JSX.Element {
  const [isVirtualSearchParam, setIsVirtualSearchParam] = useBooleanSearchParam(ProviderFinderParam.IsVirtual)
  const intl = useIntl()
  const { mutate: addMemberAction } = useMemberActionTracking()
  const { resolvedJourney } = useJourney()
  return (
    <Box
      display="flex"
      flexDirection="column"
      padding={(theme) => theme.spacing(theme.tokens.spacing.sm)}
      sx={(theme) => ({
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.tokens.borderRadius.sm
      })}
    >
      <Box
        data-id="virtual-providers-filter"
        display="flex"
        flexDirection="column"
        gap={(theme) => theme.spacing(theme.tokens.spacing.md)}
      >
        <FormControl>
          <FormControlLabel
            label={
              <Box
                component="span"
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: (theme) => theme.spacing(theme.tokens.spacing.xxs),
                  minBlockSize: (theme) => theme.spacing(theme.tokens.spacing.lg)
                }}
              >
                <Typography fontWeight="bold" textTransform="uppercase" fontSize="0.75rem">
                  <FormattedMessage defaultMessage="Virtual services available" />
                </Typography>
              </Box>
            }
            aria-label={intl.formatMessage({ defaultMessage: "Select providers who offer virtual services" })}
            control={
              <Checkbox
                name="isVirtual"
                checked={isVirtualSearchParam}
                onChange={(event) => {
                  const isChecked = event.target.checked
                  setIsVirtualSearchParam(isChecked)
                  addMemberAction({
                    memberActionTaken: MemberActions.PROVIDER_FINDER_VIRTUAL_FILTER_TOGGLED,
                    metaData: {
                      filterEnabled: isChecked,
                      memberJourney: resolvedJourney
                    }
                  })
                }}
              />
            }
          />
          <FormHelperText sx={{ paddingInlineStart: (theme) => theme.spacing(theme.tokens.spacing.xxl) }}>
            <FormattedMessage defaultMessage="Availability of virtual services may vary based on provider license and your location" />
          </FormHelperText>
        </FormControl>
      </Box>
    </Box>
  )
}
